/* istanbul ignore file */

import { css } from 'styled-components';
export var smallElevation = /*#__PURE__*/css(["box-shadow:0 2px 4px 0 rgba(0,0,0,0.2);"]);
export var mediumElevation = /*#__PURE__*/css(["box-shadow:0 4px 8px 0 rgba(0,0,0,0.2);"]);
export var largeElevation = /*#__PURE__*/css(["box-shadow:0px 8px 16px 0px rgba(30,30,41,0.16);"]);